const dataAccessMethods = require('../../dataAccessMethods');
const { config } = require('@sstdev/lib_metadata-config');
const Blockly = require('blockly');
const setupAddCodeProperties = require('../../helpers/addCodeProperties');
const convertToBoolean = require('../../helpers/convertToBoolean');
const { validationReporter } = require('../../helpers/validationReporter');

const baseMdcBlockGroup = require('./_BaseMdcBlockGroup');
class List extends baseMdcBlockGroup {
    addCodeGeneratorCustom(code, blocklyBlock, hNodeType) {
        const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);

        addCodeProperties(['initialOrderBy', 'initialSort', 'filterAction', 'rowClickAction', 'namespace', 'relation']);

        addCodeProperties([
            { key: 'includeCheckbox', handler: convertToBoolean },
            { key: 'singleRowSelect', handler: convertToBoolean },
            { key: 'allowCustomization', handler: convertToBoolean },
            { key: 'attachSelectedLocationId', handler: convertToBoolean }
        ]);

        // Validate: only 1 column can have pinOnMobile set to true
        const columnsInput = blocklyBlock.getInput('columns');
        if (columnsInput && columnsInput.connection) {
            let columnBlock = columnsInput.connection.targetBlock();
            let pinOnMobileCount = 0;
            while (columnBlock) {
                const pinOnMobileValue = columnBlock.getFieldValue('pinOnMobile');
                if (pinOnMobileValue === 'TRUE' || pinOnMobileValue === true) {
                    pinOnMobileCount++;
                }
                columnBlock = columnBlock.getNextBlock();
            }
            if (pinOnMobileCount > 1) {
                validationReporter(
                    `Only 1 column can be pinned on mobile. Found ${pinOnMobileCount} columns with "Pin On Mobile" enabled.`,
                    blocklyBlock.id
                );
            }
        }

        if (hNodeType === 'SensorReadList') {
            addCodeProperties([
                'sensorType',
                'scanType',
                'intervalMilliseconds',
                { key: 'displayShowUnknownTags', handler: convertToBoolean },
                'textForShowUnknownTagsCheckbox',
                { key: 'mergeNamespace', value: 'namespace' },
                { key: 'mergeRelation', value: 'relation' },
                { key: 'namespace', handler: () => 'sensor' },
                { key: 'relation', handler: () => 'read' }
            ]);
        }
        return JSON.stringify(code);
    }

    addToBlocksCustom(color, blocklyBlock, hNodeType) {
        let blockId = blocklyBlock.id;
        let workspace = blocklyBlock.workspace;
        blocklyBlock.setInputsInline(false);
        if (hNodeType === 'SensorReadList') {
            blocklyBlock
                .appendDummyInput()
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField('  Sensor Type:')
                .appendField(
                    new Blockly.FieldDropdown([
                        ['RFID', 'RFID'],
                        ['BLE', 'BLE']
                    ]),
                    'sensorType'
                )
                .appendField('  Scan type:')
                .appendField(
                    new Blockly.FieldDropdown([
                        ['Continuous', 'Continuous'],
                        ['On Request', 'OnRequest']
                    ]),
                    'scanType'
                )
                .appendField('  Scan Length (milliseconds):')
                .appendField(new Blockly.FieldNumber(6000, 500, 30000, 500), 'intervalMilliseconds');

            blocklyBlock
                .appendDummyInput()
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField('  Merges scanned ID with tag ID from namespace:')
                .appendField(new Blockly.FieldDropdown(dataAccessMethods.getNamespaces), 'namespace')
                .appendField(' and relation:')
                .appendField(
                    new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId)),
                    'relation'
                );

            blocklyBlock
                .appendDummyInput()
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField('  Display "Show Unknown Tags" Checkbox: ')
                .appendField(new Blockly.FieldCheckbox(false), 'displayShowUnknownTags')
                .appendField('  Text for "Show Unknown Tags" Checkbox: ')
                .appendField(new Blockly.FieldTextInput('Show Unknown Tags'), 'textForShowUnknownTagsCheckbox');
        } else {
            blocklyBlock
                .appendDummyInput()
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField('Namespace:')
                .appendField(new Blockly.FieldDropdown(dataAccessMethods.getNamespaces), 'namespace')
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField('  Relation:')
                .appendField(
                    new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId)),
                    'relation'
                );
        }
        let currentFieldRow = blocklyBlock.appendDummyInput().setAlign(Blockly.ALIGN_RIGHT);
        if (hNodeType !== 'SensorReadList') {
            currentFieldRow = currentFieldRow
                .appendField('Include Selection Column:')
                .appendField(new Blockly.FieldCheckbox('false'), 'includeCheckbox')
                .appendField('Only Allow A Single Selection:')
                .appendField(new Blockly.FieldCheckbox('false'), 'singleRowSelect');
        }
        const rowClickDropDown = new Blockly.FieldDropdown(config.actionElementActions);
        rowClickDropDown.setValue('edit');
        currentFieldRow.appendField('    Row Click Action:').appendField(rowClickDropDown, 'rowClickAction');

        blocklyBlock
            .appendDummyInput()
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField('Allow Column Customization:')
            .appendField(new Blockly.FieldCheckbox('false'), 'allowCustomization');

        if (hNodeType !== 'SensorReadList') {
            // Opt-in for a row's Edit click to carry the search pane's currently selected location
            // (namespace:relation._id 'location:location') along as locationId, so an edit rule can
            // resolve it (e.g. Order Confirmation's Start button -- see #1792). Off by default: a
            // rule keyed only on verb/namespace/relation has no way to tell which grid a click came
            // from, so this must be an explicit per-grid choice, not automatic for every grid on the
            // same namespace/relation.
            blocklyBlock
                .appendDummyInput()
                .setAlign(Blockly.ALIGN_RIGHT)
                .appendField('Attach Selected Location Id On Row Click:')
                .appendField(new Blockly.FieldCheckbox('false'), 'attachSelectedLocationId');
        }

        blocklyBlock.appendStatementInput('columns').setCheck(['listColumn']).appendField('List Columns:');

        if (hNodeType !== 'SensorReadList') {
            blocklyBlock.appendStatementInput('filters').setCheck(['filter']).appendField('Filters:');
        }
    }

    customizeToolbox(section) {
        section.contents.forEach(block => {
            if (block.type !== 'list_SensorReadList') {
                block.inputs = {
                    filters: {
                        block: {
                            type: 'filter_Paged',
                            fields: { pageSize: '25' }
                        }
                    }
                };
            }
        });
    }
}

module.exports = List;
